export default "__VITE_ASSET__BRupvo3j__"